import React, { useCallback, useState } from 'react'
import { AuthenticationClient } from 'kach-clients'
import { Button } from 'ui/components/button'
import { useError } from '../hooks/useError'
import { toast } from 'sonner'

export const ResendEmailVerificationSCN = (props: { resendToken: string }) => {
  const { getErrorMessage } = useError()
  const [isLoading, setIsLoading] = useState(false)

  const onResendEmailVerification = useCallback(async () => {
    setIsLoading(true)
    const promise = AuthenticationClient.resendEmailVerification(
      props.resendToken,
    )
    toast.promise(promise, {
      loading: 'Reenviando correo de verificación...',
      success: 'Correo de verificación reenviado',
      error: (err) => {
        return getErrorMessage(err)
      },
    })
    await promise
  }, [props.resendToken])

  return (
    <Button onClick={onResendEmailVerification} isLoading={isLoading}>
      Reenviar correo de verificación
    </Button>
  )
}
